import axios from 'axios';
import {
  JobsListParams,
  JobsListResponse,
} from '../interface/jobs.interface';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class JobsService {
  private axiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 15000,
  });

  /**
   * Fetch the public list of active jobs with optional filters.
   */
  public async getPublicJobs(params: JobsListParams = {}): Promise<JobsListResponse> {
    const response = await this.axiosInstance.get<JobsListResponse>('/jobs/public', {
      params,
    });
    return response.data;
  }
}

export const jobsService = new JobsService();
